import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class MediumService {
static mediumCreate = async (values) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/medium/create",
        data: values,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static mediumDetailsSearch = async (rowsPerPage, page, searchTerm) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/medium/admin/search",
        data: {
          filter: [],
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static mediumDetailsID = async (mediumID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/medium/admin/" + mediumID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let mediumDetailID = response.data.data;

      return mediumDetailID;
    } catch (err) {
      throw err;
    }
  };

  static mediumDelete = async (mediumID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/medium/admin/" + mediumID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static mediumUpdate = async (mediumID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/medium/" + mediumID,
        data: bodydata,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static mediums = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/medium/get/all",
        headers: {
            Authorization: `Bearer ${authToken}`,
          },
      });
      let mediumsDetail = response.data.data;
      return mediumsDetail;
    } catch (err) {
      throw err;
    }
  };

}
